import Axios, { AxiosInstance } from 'axios';
import EndpointFactory from 'axios-endpoints';

import useInterceptors from '../interceptor';
import userPreferencesInterceptor from '../interceptor/interceptors/userPreferences';

const API: AxiosInstance = useInterceptors(Axios.create(), [userPreferencesInterceptor]);

const Endpoint = EndpointFactory(API);

export const acceptTermsEndpoint = new Endpoint<{}>('/termsAccept');
